import React from 'react'
import {Route, IndexRoute} from 'react-router'
import {SendToDeviceV2Container} from '../SendToDeviceV2'
import {RouteShowPageContainer} from '../RouteShowPage'

export const routes = (
  <Route>
    <Route path='send_to_device' component={SendToDeviceV2Container} />
    <IndexRoute component={RouteShowPageContainer} />
  </Route>
)
